import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetQAEmailConfigurations_qaEmailConfigurationConnections_qaEmailConfigurations_company as GetQAEmailConfigurationsCompanyGenerated,
  GetQAEmailConfigurations as GetQAEmailConfigurationsGenerated,
  GetQAEmailConfigurations_qaEmailConfigurationConnections_qaEmailConfigurations_user as GetQAEmailConfigurationsUserGenerated,
  GetQAEmailConfigurationsVariables as GetQAEmailConfigurationsVariablesGenerated,
} from "core/queries/__generated__/GetQAEmailConfigurations";

export interface GetQAEmailConfigurationsVariables
  extends GetQAEmailConfigurationsVariablesGenerated {}
export interface GetQAEmailConfigurationsResponse
  extends GetQAEmailConfigurationsGenerated {}

export interface GetQAEmailConfigurationsUser
  extends GetQAEmailConfigurationsUserGenerated {}

export interface GetQAEmailConfigurationsCompany
  extends GetQAEmailConfigurationsCompanyGenerated {}

export const getQAEmailConfigurations = gql`
  query GetQAEmailConfigurations(
    $filters: QaEmailConfigurationFilterInput
    $pagination: Pagination
  ) {
    qaEmailConfigurationConnections(
      filters: $filters
      pagination: $pagination
    ) {
      total
      cursor
      hasMore
      qaEmailConfigurations {
        id
        user {
          id
          name
          firstName
          lastName
          email
          avatar: profilePicture {
            id
            url
          }
        }
        company {
          id
          name
        }
      }
    }
  }
`;

export interface UseGetQAEmailConfigurations {
  skip?: boolean;
  variables: GetQAEmailConfigurationsVariables;
}

export const useGetQAEmailConfigurations = ({
  skip,
  variables,
}: UseGetQAEmailConfigurations) =>
  useQuery<GetQAEmailConfigurationsResponse, GetQAEmailConfigurationsVariables>(
    getQAEmailConfigurations,
    {
      skip,
      fetchPolicy: "cache-and-network",
      variables,
    },
  );
